"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFilesInEvaluation = exports.removeFileInEvaluation = exports.remove = void 0;
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var lodash_1 = __importDefault(require("lodash"));
var FirebaseUtils_1 = require("../firebase/FirebaseUtils");
var firebase = __importStar(require("../firebase/fbase"));
var Storage = __importStar(require("../storage/StorageManager"));
var EvaluationLoader = __importStar(require("./EvaluationLoader"));
var EvaluationLoader_1 = require("./EvaluationLoader");
var EvaluationUtils_1 = require("./EvaluationUtils");
function remove(evalType, evaluationName) {
    return __awaiter(this, void 0, void 0, function () {
        var editable, targetCollectionName, docRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(evalType, evaluationName)];
                case 1:
                    editable = _a.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(evaluationName, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    targetCollectionName = Evaluation.getKoEvaluation(evalType);
                    docRef = firebase.dbService.collection(targetCollectionName).doc(evaluationName);
                    return [4 /*yield*/, (0, FirebaseUtils_1.removeDocument)(docRef, [EvaluationUtils_1.STATE_DOC_NAME, EvaluationUtils_1.CONTENT_DOC_NAME])];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Storage.deleteEvaluationFiles(evalType, evaluationName)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.remove = remove;
function removeFileInfo(basefile) {
    return __awaiter(this, void 0, void 0, function () {
        var content, emptyFile, docRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, EvaluationLoader.getContent(basefile.evaluationType, basefile.evaluationName, basefile.controlId)];
                case 1:
                    content = _a.sent();
                    emptyFile = {
                        type: basefile.type,
                        evaluationType: basefile.evaluationType,
                        evaluationName: basefile.evaluationName,
                        name: '',
                        controlId: basefile.controlId,
                        state: BaseFile_1.FileState.EMPTY,
                        file: undefined,
                        updateTime: '',
                        updater: '',
                        checked: false
                    };
                    docRef = firebase.dbService
                        .collection(Evaluation.getKoEvaluation(basefile.evaluationType))
                        .doc(basefile.evaluationName)
                        .collection(EvaluationUtils_1.CONTENT_DOC_NAME)
                        .doc(basefile.controlId);
                    if (!(basefile.type === BaseFile_1.FileType.Record)) return [3 /*break*/, 3];
                    return [4 /*yield*/, docRef.update({ 'files.record': emptyFile })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 10];
                case 3:
                    if (!(basefile.type === BaseFile_1.FileType.Population)) return [3 /*break*/, 5];
                    return [4 /*yield*/, docRef.update({ 'files.population': emptyFile })];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 10];
                case 5:
                    if (!(basefile.type === BaseFile_1.FileType.Evidence)) return [3 /*break*/, 8];
                    if (content.files.evidence && basefile.name in content.files.evidence) {
                        delete content.files.evidence[basefile.name];
                    }
                    if (!content.files.evidence) return [3 /*break*/, 7];
                    return [4 /*yield*/, docRef.update({ 'files.evidence': content.files.evidence })];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8:
                    if (content.files.extra && basefile.name in content.files.extra) {
                        delete content.files.extra[basefile.name];
                    }
                    return [4 /*yield*/, docRef.update({ 'files.extra': content.files.extra })];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    });
}
function removeFileInEvaluation(basefile) {
    return __awaiter(this, void 0, void 0, function () {
        var editable, filePath;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(basefile.evaluationType, basefile.evaluationName)];
                case 1:
                    editable = _a.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(basefile.evaluationName, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    return [4 /*yield*/, removeFileInfo(basefile)];
                case 2:
                    _a.sent();
                    filePath = lodash_1.default.join([
                        Evaluation.getKoEvaluation(basefile.evaluationType),
                        basefile.evaluationName,
                        basefile.controlId,
                        basefile.name
                    ], '/');
                    return [4 /*yield*/, Storage.deleteFile(filePath)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.removeFileInEvaluation = removeFileInEvaluation;
function removeFilesInEvaluation(basefiles) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(basefiles, function (basefile) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, removeFileInEvaluation(basefile)];
                    }); }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.removeFilesInEvaluation = removeFilesInEvaluation;
//# sourceMappingURL=EvaluationRemover.js.map